// extracted by mini-css-extract-plugin
export default {"profileTab":"styles_profileTab__By-4g","card":"styles_card__TlXJ3","cardImage":"styles_cardImage__2YBUD"};